// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  reservation: {
    name: 'reservation',
    componentName: 'Reservation',
    chunk: () => import(
      /* webpackChunkName: "reservation" */
      './pages/Reservation'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Reservation.js')).Reservation
        : currentRouteName === 'reservation'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Reservation })));
    },
    path: '/:context?/p/rental/reservations/:slug?/:itemId',
    channel: null
  },
  delivery: {
    name: 'delivery',
    componentName: 'Delivery',
    chunk: () => import(
      /* webpackChunkName: "delivery" */
      './pages/Delivery'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Delivery.js')).Delivery
        : currentRouteName === 'delivery'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Delivery })));
    },
    path: '/:context?/p/rental/delivery/:slug?/:itemId',
    channel: null
  },
  clearCallback: {
    name: 'clearCallback',
    componentName: 'ClearCallback',
    chunk: () => import(
      /* webpackChunkName: "clearCallback" */
      './pages/ClearCallback'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ClearCallback.js')).ClearCallback
        : currentRouteName === 'clearCallback'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ClearCallback })));
    },
    path: '/:context?/rental/clear-verification/callback',
    channel: null
  },
  clearVerification: {
    name: 'clearVerification',
    componentName: 'ClearVerification',
    chunk: () => import(
      /* webpackChunkName: "clearVerification" */
      './pages/ClearVerification'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ClearVerification.js')).ClearVerification
        : currentRouteName === 'clearVerification'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ClearVerification })));
    },
    path: '/:context?/rental/clear-verification/:clearState',
    channel: null
  },
  clearCallbackV2: {
    name: 'clearCallbackV2',
    componentName: 'ClearCallbackV2',
    chunk: () => import(
      /* webpackChunkName: "clearCallbackV2" */
      './pages/ClearCallbackV2'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ClearCallbackV2.js')).ClearCallbackV2
        : currentRouteName === 'clearCallbackV2'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ClearCallbackV2 })));
    },
    path: '/:context?/rental/clear-verification/v2/callback/:uuid',
    channel: null
  },
  selfDropoff: {
    name: 'selfDropoff',
    componentName: 'SelfDropoff',
    chunk: () => import(
      /* webpackChunkName: "selfDropoff" */
      './pages/SelfDropoff'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/SelfDropoff.js')).SelfDropoff
        : currentRouteName === 'selfDropoff'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.SelfDropoff })));
    },
    path: '/:context?/rental/self-dropoff/:storeId',
    channel: null
  },
  reservationDetails: { // TODO: Remove once transitioned off
    name: 'reservationDetails',
    componentName: 'ReservationDetails',
    chunk: () => import(
      /* webpackChunkName: "reservationDetails" */
      './pages/ReservationDetails'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ReservationDetails.js')).ReservationDetails
        : currentRouteName === 'reservationDetails'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ReservationDetails })));
    },
    path: '/:context?/p/rental/reservationDetails',
    channel: null
  },
  manageReservation: {
    name: 'manageReservation',
    componentName: 'ManageReservation',
    chunk: () => import(
      /* webpackChunkName: "manageReservation" */
      './pages/ManageReservation'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ManageReservation.js')).ManageReservation
        : currentRouteName === 'manageReservation'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ManageReservation })));
    },
    path: '/:context?/rental/manage-reservation/:uuid/:reservationId/:storeId',
    channel: null
  },
  cancelReservation: {
    name: 'cancelReservation',
    componentName: 'CancelReservation',
    chunk: () => import(
      /* webpackChunkName: "cancelReservation" */
      './pages/CancelReservation'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/CancelReservation.js')).CancelReservation
        : currentRouteName === 'cancelReservation'
          ? currentRouteComponent
          : generateAsyncRoute(
            () => this.chunk().then((pageModule) => ({ default: pageModule.CancelReservation }))
          );
    },
    path: '/:context?/rental/cancel-reservation/:cancellationId/:reservationNumber',
    channel: null
  },
  product: {
    name: 'product',
    componentName: 'Product',
    chunk: () => import(
      /* webpackChunkName: "product" */
      './pages/Product'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Product.js')).Product
        : currentRouteName === 'product'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Product })));
    },
    path: '/:context?/p/rental/:slug?/:itemId',
    channel: null
  },

});

export const getRouteChunk = async (currentRouteName) => {
  const routes = getRoutes();
  const routeKey = Object.keys(routes).filter((key) => routes[key].name === currentRouteName)[0];
  const route = routes[routeKey];
  const componentModule = await route.chunk();

  return componentModule[route.componentName];
};
